module.exports = __webpack_public_path__ + "img/Unidad13-1.76e35b30.png";